import { render, staticRenderFns } from "./wt-upload-file.vue?vue&type=template&id=b7a23cec&"
import script from "./wt-upload-file.vue?vue&type=script&lang=js&"
export * from "./wt-upload-file.vue?vue&type=script&lang=js&"
import style0 from "./wt-upload-file.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports